module.exports = __webpack_public_path__ + "img/full5-min.d827b42e.png";